const Nav = (el) => {
    const clickOutside = el.dataset.clickOutside === 'true';

    el.addEventListener('click', (e) => {
        e.preventDefault();

        const parent = el.closest('li');

        // Find if allow multiple is false, will always default to true
        const allowMultiple = el.dataset.allowMultiple;
        const onlyOneOpen = allowMultiple === 'false';

        const toggle = parent.querySelector(el.dataset.toggle);
        const isOpen = el.classList.contains('js-state-nav--active');
        if(isOpen) {
            closeElement(el, toggle);
        } else {
            if(onlyOneOpen) {
                closeAll(parent);
            }

            openElement(el, toggle);

            // If click outside activated, make sure this is closed when clicking outside of element
            if(clickOutside) {
                closeOnClickOutside(parent, el, toggle);
            }
        }
    });
};

const closeElement = (el, toggle) => {
    toggle.classList.remove('js-state-nav--open');
    toggle.classList.add('js-state-nav--closed');
    el.classList.remove('js-state-nav--active');
};

const openElement = (el, toggle) => {
    toggle.classList.add('js-state-nav--open');
    toggle.classList.remove('js-state-nav--closed');
    el.classList.add('js-state-nav--active');
};

// Any click inside parent element of open menu should keep menu open
const closeOnClickOutside = (parent, el, toggle) => {
    const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

    const outsideClickListener = event => {
        if (!parent.contains(event.target) && isVisible(parent)) {
            closeElement(el, toggle);
            removeClickListener();
        }
    }

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener);
    }

    document.addEventListener('click', outsideClickListener);
};

const closeAll = (parent) => {
    const siblings = parent.closest('ul').children;
    for(let i = 0; i < siblings.length; i++) {
        const sibling = siblings[i];
        if(sibling !== parent) {
            const el = sibling.querySelector('.js-toggle-nav');
            if(el) {
                const toggle = sibling.querySelector(el.dataset.toggle);
                closeElement(el, toggle);
            }
        }
    }
};

export default Nav;
